// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acteco-field {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Matches the inline label style used by the other fields in the modal. */
.acteco-label {
  font-size: var(--fs-ui);
  font-weight: 500;
  color: var(--text-secondary);
}

.acteco-error {
  font-size: var(--fs-meta);
  color: var(--danger);
}

.acteco-listbox {
  width: 100%;
  box-sizing: border-box;
  margin: 4px 0 0;
  padding: 4px;
  list-style: none;
  max-height: 240px;
  overflow-y: auto;
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-0);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
  /* Match the mono inputs (RUT/email/etc.): same family and size. */
  font-family: var(--mono);
  font-size: var(--fs-2xs);
}

.acteco-option {
  display: flex;
  gap: 8px;
  align-items: baseline;
  padding: 6px 8px;
  border-radius: 2px;
  cursor: pointer;
  font-size: var(--fs-2xs);
  color: var(--text-secondary);
}

.acteco-option:hover,
.acteco-option.Mui-focused,
.acteco-option[aria-selected='true'] {
  background: var(--bg-alt);
  color: var(--text);
}

/* Code identifier: mono like the rest, dimmed so the description reads as primary. */
.acteco-option__code {
  font-family: var(--mono);
  font-size: var(--fs-2xs);
  color: var(--text-muted);
  min-width: 56px;
  flex-shrink: 0;
}

.acteco-option__activity {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/facturacion/ActecoSelect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,0EAA0E;AAC1E;EACE,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;EAC9B,0CAA0C;EAC1C,kEAAkE;EAClE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;;;EAGE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,qFAAqF;AACrF;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;AACT","sourcesContent":[".acteco-field {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* Matches the inline label style used by the other fields in the modal. */\n.acteco-label {\n  font-size: var(--fs-ui);\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.acteco-error {\n  font-size: var(--fs-meta);\n  color: var(--danger);\n}\n\n.acteco-listbox {\n  width: 100%;\n  box-sizing: border-box;\n  margin: 4px 0 0;\n  padding: 4px;\n  list-style: none;\n  max-height: 240px;\n  overflow-y: auto;\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-0);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);\n  /* Match the mono inputs (RUT/email/etc.): same family and size. */\n  font-family: var(--mono);\n  font-size: var(--fs-2xs);\n}\n\n.acteco-option {\n  display: flex;\n  gap: 8px;\n  align-items: baseline;\n  padding: 6px 8px;\n  border-radius: 2px;\n  cursor: pointer;\n  font-size: var(--fs-2xs);\n  color: var(--text-secondary);\n}\n\n.acteco-option:hover,\n.acteco-option.Mui-focused,\n.acteco-option[aria-selected='true'] {\n  background: var(--bg-alt);\n  color: var(--text);\n}\n\n/* Code identifier: mono like the rest, dimmed so the description reads as primary. */\n.acteco-option__code {\n  font-family: var(--mono);\n  font-size: var(--fs-2xs);\n  color: var(--text-muted);\n  min-width: 56px;\n  flex-shrink: 0;\n}\n\n.acteco-option__activity {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
